(function () {
  var cartDrawer = document.querySelector('drawer-component#Drawer-Cart');
  if (!cartDrawer) return;

  document.querySelectorAll('[data-cart-drawer-trigger]').forEach(function (trigger) {
    trigger.addEventListener('click', function (e) {
      var behavior = trigger.getAttribute('data-cart-behavior');
      if (behavior && behavior !== 'drawer') return; // let it navigate to /cart normally
      e.preventDefault();
      if (typeof cartDrawer.openDrawer === 'function') {
        cartDrawer.openDrawer();
      }
    });
  });

  document.addEventListener('cart:updated', function (e) {
    var cart = e.detail.cart;
    document.querySelectorAll('[data-cart-count]').forEach(function (el) {
      el.textContent = cart.item_count;
      el.hidden = cart.item_count === 0;
    });
  });
})();